import { useContext, useEffect } from 'react';

import { BrandSystemContext } from '../contexts/BrandSystemContext';
import { getParams } from './getParams';

export interface UseParamsProps {
  [key: number | string]: string;
}

export const insertUrlParam = (name: any, value: any) => {
  if (typeof window === 'undefined') return;

  const _searchParams = new URLSearchParams(window.location.search);

  _searchParams.set(name, value);

  if (window?.history?.pushState) {
    const newurl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname +
      '?' +
      _searchParams.toString();

    window.history.pushState({ path: newurl }, '', newurl);
  }

  return getParams();
};

export const useParams = () => {
  const { urlParams, setUrlParams }: any = useContext(BrandSystemContext);

  useEffect(() => {
    if (!urlParams && typeof setUrlParams === 'function') {
      setUrlParams(getParams());
    }
  }, [setUrlParams, urlParams]);

  const updateParams = (name: any, value: any) => {
    insertUrlParam(name, value);
    typeof setUrlParams === 'function' && setUrlParams(getParams());
  };

  return [getParams(), updateParams] as [UseParamsProps, any];
};
